import get from 'lodash/get'

import {
  CHANGE_PANEL_TYPE,
  TOGGLE_DETAILS_PANEL,
  DISPLAY_DETAILS_PANEL,
  NEW_PANEL_DATA,
  CHANGE_BORDER_RADIUS,
  TOGGLE_BOX_SHADOW,
  TOGGLE_TOP_NAVIGATION,
  FROM_FIELD,
  SUBMIT_LOADING,
  TOGGLE_MENU_ACTIONS

} from '../actions/detailsPanelActions';

import {
  RESET_ACCOUNT,
  LOG_OUT

} from '../actions/accountActions';

const initialState = {
  open: false,
  hooks: {
    onSave: () => {},
    onClose: () => {},
    onError: () => {}
  },
  isLoading: false,
  isLoadingButton: false,
  type: null,
  data: {},
  squaredCorners: false,
  withBoxShadow: false,
  topNavigation: false,
  field:null,
  showActions: false

}; // END initialState

export default function (state = initialState, action) {
  let { payload, type } = action;
  switch (type) {
    case CHANGE_PANEL_TYPE:
      return { ...state, ...payload };

    case NEW_PANEL_DATA:
      return { ...state, ...payload };

    case TOGGLE_DETAILS_PANEL:
      return { ...state, open: !state.open };

    case DISPLAY_DETAILS_PANEL:
      const open = get(payload, 'open');
      if (open === false) payload.hooks = initialState.hooks;
      return { ...state, ...payload }

    case CHANGE_BORDER_RADIUS:
      return { ...state, squaredCorners: !state.squaredCorners };

    case TOGGLE_BOX_SHADOW:
      return { ...state, withBoxShadow: !state.withBoxShadow };

    case TOGGLE_TOP_NAVIGATION:
      return { ...state, topNavigation: !state.topNavigation };

    case TOGGLE_MENU_ACTIONS:
      const show = get(payload, show) 
      return { ...state, showActions: !state.showActions };

    case RESET_ACCOUNT:
    case LOG_OUT:
      return { ...state, ...initialState };

    case FROM_FIELD:
      return { ...state, ...payload };

    case SUBMIT_LOADING:
      return {...state, ...payload };

    default:
      return state;

  } // END switch

} // END default



// WEBPACK FOOTER //
// ./src/redux/reducers/detailsPanelReducer.js